import { render } from "./StaffDelegation.vue?vue&type=template&id=2519b0f4&scoped=true"
import script from "./StaffDelegation.vue?vue&type=script&lang=js"
export * from "./StaffDelegation.vue?vue&type=script&lang=js"

import "./StaffDelegation.vue?vue&type=style&index=0&id=2519b0f4&lang=scss&scoped=true"
import "./StaffDelegation.vue?vue&type=style&index=1&id=2519b0f4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2519b0f4"]])

export default __exports__